import { render, staticRenderFns } from "./QLabeledSwitch.vue?vue&type=template&id=8f0164ea&"
import script from "./QLabeledSwitch.vue?vue&type=script&lang=js&"
export * from "./QLabeledSwitch.vue?vue&type=script&lang=js&"
import style0 from "./QLabeledSwitch.vue?vue&type=style&index=0&id=8f0164ea&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports